module.exports = __webpack_public_path__ + "img/GrantsConstraintsPlans.598a96c3.svg";